import { inject, injectable } from 'inversify';
import * as moment from 'moment';

import { HttpService } from 'src/core/services/http.service';
import { ObjectUtils } from 'src/core/utils/object';



@injectable()
export class ErratasService {
	constructor(
		@inject(HttpService)
		private httpService: HttpService
	) { }

	private baseUrl = 'api/v1/products/erratas';

	async erratasProduct( productId: number, bookingDate: Date, serviceDateFrom: Date, serviceDateTo: Date, supplierId: number): Promise<ErratasQuoteEntryItem> {
		const body = {
			productId: productId,
			bookingDate: bookingDate,
			serviceDateFrom: serviceDateFrom,
			serviceDateTo: serviceDateTo,
			supplierId: supplierId
		};
		const response = await this.httpService.post(`${this.baseUrl}/ErratasProduct`, body);
		return response.data as ErratasQuoteEntryItem;
	}

	async getErratasForAllQuoteEntries(request: AllErratasParameterRequest): Promise<ErratasQuoteEntryItem[]> {

		const body = {
			bookingDate: request.bookingDate,
			erratasParameter:request.erratasParameter.slice()
		};
		const response = await this.httpService.post(`${this.baseUrl}/GetErratasForAllQuoteEntries`, body);
		return response.data as ErratasQuoteEntryItem[];
	}

	
}



// WEBPACK FOOTER //
// ./src/app/bookings/shared/erratas.service.ts